/*
 * Purpose: GitHub OAuth sign-in for multitenancy portal
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import { AUTH_CONFIG, authUrl } from '@/lib/auth-config';
import { useAuthStore } from '@/stores/authStore';
import { AuthButtonOutline } from '@/components/auth/ui/AuthUi';

export function GitHubSignInButton({
  next = '/dashboard',
  onSignedIn,
}: {
  next?: string;
  onSignedIn?: () => void;
}) {
  const signIn = useAuthStore((s) => s.signIn);
  const enabled = AUTH_CONFIG.enabledMethods.includes('github_oauth');

  if (!enabled) return null;

  function startGitHub() {
    if (AUTH_CONFIG.mock) {
      signIn('github-user@autoblocks.run');
      onSignedIn?.();
      if (!onSignedIn) window.location.href = next;
      return;
    }
    const params = new URLSearchParams({ next });
    if (typeof window !== 'undefined') {
      params.set('origin', window.location.origin);
      const { hostname } = window.location;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        params.set(
          'callback',
          `${window.location.origin}${AUTH_CONFIG.endpoints.githubCallback}`,
        );
      }
    }
    const url = `${authUrl(AUTH_CONFIG.endpoints.githubStart)}?${params}`;
    window.location.href = url;
  }

  return (
    <div className="space-y-3">
      <AuthButtonOutline type="button" onClick={startGitHub}>
        <span className="inline-flex items-center justify-center gap-2">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
            <path d="M12 0C5.37 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.6.113.793-.261.793-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.729.083-.729 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.418-1.305.762-1.606-2.665-.303-5.466-1.332-5.466-5.93 0-1.31.468-2.38 1.236-3.22-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.3 1.23a11.5 11.5 0 0 1 3.003-.404c1.02.005 2.047.138 3.003.404 2.29-1.552 3.297-1.23 3.297-1.23.653 1.652.242 2.873.12 3.176.77.84 1.235 1.911 1.235 3.22 0 4.61-2.807 5.625-5.479 5.921.43.372.823 1.102.823 2.222 0 1.606-.015 2.898-.015 3.293 0 .319.192.694.801.576C20.566 21.796 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
          </svg>
          Continue with GitHub
        </span>
      </AuthButtonOutline>
      <div className="relative flex items-center gap-3 py-1">
        <span className="h-px flex-1 bg-border" />
        <span className="text-xs text-muted-foreground">or use email</span>
        <span className="h-px flex-1 bg-border" />
      </div>
    </div>
  );
}

export default GitHubSignInButton;
